import { StateCreator } from "zustand";
import { Organization } from "../services/Organization";

export interface OrganizationSlice {
  organizations: Organization[];
  selectedOrganizationId: string | null;
  setOrganizations: (organizations: Organization[]) => void;
  setSelectedOrganizationId: (organizationId: string | null) => void;
  getSelectedOrganizationId: () => string | null;
  getOrganizations: () => Organization[];
}

export const createOrganizationSlice: StateCreator<
  OrganizationSlice,
  [],
  [],
  OrganizationSlice
> = (set, get, _) => ({
  organizations: [],
  selectedOrganizationId: null,
  setOrganizations: (organizations: Organization[]) => set(() => ({ organizations })),
  setSelectedOrganizationId: (selectedOrganizationId: string | null) =>
    set(() => ({ selectedOrganizationId })),
  getSelectedOrganizationId: () => get().selectedOrganizationId,
  getOrganizations: () => get().organizations,
});
